import React from 'react';
import {POCToolSummaryWebPortal} from '../../../models/IPOCToolWebPortal';
import moment from 'moment';
import {Grid} from '@mui/material';
import {Link} from 'react-router-dom';
import {sanitizeURL} from '../../../Util/sanitizeURL';

type Props = {
  summary: POCToolSummaryWebPortal;
  isPressable?: boolean;
};

export default function POCToolSummaryItem(props: Props) {
  const {summary, isPressable = true} = props;
  let date: any = moment(summary.lastUpdated);
  if (!date.isValid()) {
    date = summary.lastUpdated;
  } else {
    date = date.format('MMM YYYY').toString();
  }
  const toolName = summary.name;
  const encodedToolName = sanitizeURL(toolName);

  return (
    <Grid item xs={3} sm={4} md={4}>
      <Link
        to={
          summary.isSuperPOCTool
            ? `/MiniTools/${encodedToolName}/${summary.id}/`
            : `/POCTool/${encodedToolName}/${summary.id}/`
        }
        style={
          isPressable
            ? styles.linkStyle
            : {pointerEvents: 'none', ...styles.linkStyle}
        }>
        <img
          src={summary.previewImageUrl}
          height={230}
          width={'100%'}
          style={styles.imageStyle}
        />
        <p style={styles.summaryTitle}>{summary.name}</p>
        <p style={styles.summaryDate}>{date}</p>
        <p style={styles.summaryDescription as React.CSSProperties}>
          {summary.description}
        </p>
      </Link>
    </Grid>
  );
}

const styles = {
  linkStyle: {
    textDecoration: 'none',
  },
  summaryTitle: {
    paddingTop: 10,
    fontSize: 20,
    fontWeight: '600',
    lineHeight: '120%',
    maxWidth: 300,
    color: '#000000',
  },
  summaryDate: {
    marginTop: -10,
    fontSize: 14,
    fontWeight: '600',
    lineHeight: '150%',
    color: '#000000',
  },
  summaryDescription: {
    marginTop: -10,
    fontSize: 16,
    fontWeight: '400',
    lineHeight: '150%',
    display: '-webkit-box',
    width: '100%',
    overflow: 'hidden',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    color: '#000000',
  },
  imageStyle: {borderRadius: 8},
};
